<template>
	<nav>
		<ul class="tabs" v-if="availableLanguages">
			<li v-for="(lang, index) in availableLanguages" :class="isActive === lang.locale ? 'active' : ''" @click.prevent="setActiveStatus(index)">
				<a href="#">
					<img :src="lang.flagIconUrl" :alt="lang.title" :title="lang.title">
					{{ lang.title }}
				</a>
			</li>
		</ul>
	</nav>
</template>

<script>
	import {eventBus} from '../app';

	export default {
		name: 'LangSelector',
		data() {
			return {
				availableLanguages: this.$availableLanguages,
				isActive: this.$defaultLanguage.locale,
			}
		},
		created() {
			let vm = this;

			/* From anywhere */
			eventBus.$on('pushActiveStatus', function (data) {
				vm.isActive = data.locale;
			});
		},
		methods: {
			setActiveStatus: function (lang_id) {
				let vm = this;

				vm.isActive = vm.availableLanguages[lang_id].locale;

				// Run this method, ArticleEditor catches when this method runs.
				/* Listening in ArticleEditor */
				eventBus.$emit('setActiveStatus', vm.isActive);
			}
		}
	}
</script>

<style lang="scss">

</style>
